import { render, staticRenderFns } from "./sendEmailNotification.vue?vue&type=template&id=72036228&"
import script from "./sendEmailNotification.vue?vue&type=script&lang=js&"
export * from "./sendEmailNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports